import * as types from './types';
import * as api from './api';
import { createCoverageActions } from '../../../common/coverage/actions';

export default createCoverageActions(types, api);
